import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

export default class EventCards {
	constructor() {
		this.swiper = undefined;
	}

	init() {
		if ($('.event-cards')[0]) {
			this.swiper = new Swiper('.event-cards__flex', {
				loop: true,
				modules: [Autoplay],
				slidesPerView: 1,
				spaceBetween: 0,
				autoplay: {
					delay: 5000,
					disableOnInteraction: false
				},
				breakpoints: {
					0: {
						slidesPerView: 1.33,
						spaceBetween: 20
					},
					767: {
						slidesPerView: 3,
						spaceBetween: 25
					}
				}
			});
		}
	}

	destroy() {
		if (this.swiper !== undefined) {
			this.swiper.destroy();
		}
	}
}
